import { createClient } from '@supabase/supabase-js'

// Replace these with your actual values from Step 4
const supabaseUrl = 'https://hvbssnitfjgmvwyjtppx.supabase.co/'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2YnNzbml0ZmpnbXZ3eWp0cHB4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMyNjUyNDgsImV4cCI6MjA3ODg0MTI0OH0.wRNAW1iCnDXW2xUXYlllFHl7awRiT4WJC6i6yhcP2nw'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)